module.exports = __webpack_public_path__ + "img/info1.f52248c4.png";